








































import { Component, Vue } from 'nuxt-property-decorator'

@Component<MBriefDecoration>({})
export default class MBriefDecoration extends Vue {
  loaded = false
  reset = true

  mounted() {
    let lastHeight = document.body.clientHeight

    setInterval(() => {
      if (lastHeight !== document.body.clientHeight) {
        this.reset = false
        lastHeight = document.body.clientHeight
        setTimeout(() => { this.reset = true }, 1)
      }
    }, 200)

    setTimeout(() => {
      this.loaded = true
    }, 2000)
  }
}
